import React from "react";
import { Link } from "react-router-dom";

export const Informativos: React.FC = () => {

  return (
    <div className={"alert alert-info"}>
      {/* Art. 4º A EFPC deve disponibilizar em seu sítio na internet, em local de acesso restrito, ou por meio de outro canal de comunicação, observado o disposto §2º do art. 13, extrato mensal da situação individual do participante ou assistido no plano de benefícios que possibilite o acompanhamento da sua evolução no plano de benefícios, que deve conter, no mínimo:
      <br />
I - nome do plano de benefícios, com respectivo Cadastro Nacional de Planos de Benefícios, Cadastro Nacional da Pessoa Jurídica quando houver;
      <br />
II - nome do participante ou assistido, seus beneficiários e dependentes, esses últimos acompanhados da data da atualização cadastral mais recente feita pelo participante;
      <br />
III - informações para encaminhamento de solicitação de informação por participante ou assistido, nos termos do art. 9º desta Resolução;
       <br /><br />*/}
      {"Para entrar em contato conosco, favor enviar e-mail para: faelce@faelce.com.br ou utilize "}

      <Link className={"btn btn-primary"} to={"relacionamento"}>nossa central de atendimento</Link>
    </div>
  );
}
